import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useFormik } from 'formik';
import View from '@/components/view';
import { useTranslations } from 'next-intl';
import ClientFetch from '@/server/fetch/client';
import { Button, Input, Textarea } from '@nextui-org/react';
import InMailContactForm from './in-mail';

const FormStatus = {
  IDLE: 'IDLE',
  SUBMITTING: 'SUBMITTING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

const ContactForm = () => {
  const t = useTranslations('contact');

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phone: '',
      message: '',
    },
    initialStatus: FormStatus.IDLE,
    onSubmit: async (values, { setStatus, resetForm }) => {
      setStatus(FormStatus.SUBMITTING);
      try {
        const { data } = await ClientFetch.post('/contact', values);
        setStatus(FormStatus.SUCCESS);
        alert(t('form.messages.success'));
        resetForm();
      } catch (error) {
        setStatus(FormStatus.ERROR);
        alert(t('form.messages.error'));
      }
    },
  });

  return (
    <React.Fragment>
      <View className="flex flex-col gap-2 mt-4 sm:mt-0 ">
        <View>
          <span className="font-bold text-base sm:text-xl primary-text">
            {t('heading')}
          </span>
          <h2 className="text-3xl sm:text-5xl tracking-wide font-bold mt-4 mb-2">
            {t('sub-heading')}
          </h2>
        </View>
        <View className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          <View className="grid gap-4">
            <View className="bg-basic flex gap-6 items-center text-white rounded-2xl p-4">
              <View>
                <View className="w-[50px] h-[50px] rounded-full bg-white flex justify-center items-center">
                  <Image
                    src={'/icons/location.gif'}
                    alt="location"
                    width={22}
                    height={22}
                  />
                </View>
              </View>
              <View className="grid gap-2">
                <h3 className="font-bold text-xl">
                  {' '}
                  {t('details.address.title')}
                </h3>
                <Link
                  target="_blank"
                  href={
                    'https://maps.google.com/maps/dir//J.+Duikerweg+13+1703+DH+Heerhugowaard+Netherlands/@52.6623246,4.8137423,17z/data=!4m5!4m4!1m0!1m2!1m1!1s0x47cf542764369ad3:0x4ec18977d3493ccd'
                  }
                  className="text-sm"
                >
                  {t('details.address.value')}
                </Link>
              </View>
            </View>
            <View className="bg-basic flex gap-6 items-center text-white rounded-2xl p-4">
              <View>
                <View className="w-[50px] h-[50px] rounded-full bg-white flex justify-center items-center">
                  <Image
                    src={'/icons/phone.gif'}
                    alt="location"
                    width={22}
                    height={22}
                  />
                </View>
              </View>
              <View className="grid gap-2">
                <h3 className="font-bold text-xl">
                  {t('details.phone.title')}
                </h3>

                <Link className="text-sm" href={'tel:+31648768146'}>
                  {t('details.phone.title')}
                </Link>
              </View>
            </View>
            <View className="bg-basic flex gap-6 items-center text-white rounded-2xl p-4">
              <View>
                <View className="w-[50px] h-[50px] rounded-full bg-white flex justify-center items-center">
                  <Image
                    src={'/icons/envelope.gif'}
                    alt="location"
                    width={22}
                    height={22}
                  />
                </View>
              </View>
              <View className="grid gap-2">
                <h3 className="font-bold text-xl">
                  {' '}
                  {t('details.email.title')}
                </h3>
                <Link
                  className="text-sm"
                  href={'mailto:info@greenconceptors.com'}
                >
                  {t('details.email.title')}
                </Link>
              </View>
            </View>
          </View>
          <View className="flex flex-col justify-between p-1">
            <InMailContactForm />
            {/* <form
              className="flex flex-col gap-4"
              onSubmit={formik.handleSubmit}
            >
              <Input
                type="text"
                name="name"
                label={t('form.fields.name.label')}
                size="lg"
                isRequired
                value={formik.values.name}
                onChange={formik.handleChange}
              />
              <Input
                type="email"
                name="email"
                label={t('form.fields.email.label')}
                size="lg"
                isRequired
                value={formik.values.email}
                onChange={formik.handleChange}
              />
              <Input
                type="tel"
                name="phone"
                label={t('form.fields.phone.label')}
                size="lg"
                value={formik.values.phone}
                onChange={formik.handleChange}
              />
              <Textarea
                name="message"
                isRequired
                label={t('form.fields.message.label')}
                rows={30}
                cols={20}
                classNames={{
                  innerWrapper: 'min-h-[180px]',
                }}
                value={formik.values.message}
                onChange={formik.handleChange}
              />
              <Button
                size="lg"
                type="submit"
                variant="ghost"
                color="primary"
                isLoading={formik.status === FormStatus.SUBMITTING}
              >
                {t('form.button.text')}
              </Button>
            </form> */}
          </View>
        </View>
      </View>
    </React.Fragment>
  );
};

export default ContactForm;
